import { Toaster } from 'react-hot-toast';

/**
 * Composant pour afficher les notifications toast
 * À inclure une seule fois dans App.js
 */
export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#fff',
          color: '#363636',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          padding: '16px',
        },
        success: {
          duration: 3000,
          style: {
            background: '#ecfdf5',
            color: '#065f46',
            border: '1px solid #a7f3d0',
          },
          icon: '✅',
        },
        error: {
          duration: 4000,
          style: {
            background: '#fef2f2',
            color: '#991b1b',
            border: '1px solid #fecaca',
          },
          icon: '❌',
        },
        loading: {
          style: {
            background: '#f0fdfb',
            color: '#0f766e',
            border: '1px solid #99f6e4',
          },
        },
        custom: {
          duration: 4000,
          style: {
            background: '#f0f9ff',
            color: '#082f49',
            border: '1px solid #bae6fd',
          },
        },
      }}
    />
  );
}
